import { render } from "./CustoVariaveis.vue?vue&type=template&id=b5f07c7a"
import script from "./CustoVariaveis.vue?vue&type=script&lang=js"
export * from "./CustoVariaveis.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__